import React, { useState } from "react";
import "gantt-task-react/dist/index.css";
import { ViewMode } from "gantt-task-react";
import { Button } from 'primereact/button';
import { Workpack } from "../helper";

type ViewSwitcherProps = {
    onViewModeChange: (viewMode: ViewMode) => void;
    workpack: Workpack | null;
    openModal: () => void;
    openTemplate: () => void;
    loading?: boolean;
};

const viewModes = [
    ViewMode.Day,
    ViewMode.Week,
    ViewMode.Month
];

export const ViewSwitcher: React.FC<ViewSwitcherProps> = ({
    onViewModeChange, openModal, workpack, openTemplate, loading = false
}) => {
    const [currentViewModeIndex, setCurrentViewModeIndex] = useState(0); // Start with Day view

    const handleZoomIn = () => {
        if (currentViewModeIndex > 0) {
            setCurrentViewModeIndex(currentViewModeIndex - 1);
            onViewModeChange(viewModes[currentViewModeIndex - 1]);
        }
    };

    const handleZoomOut = () => {
        if (currentViewModeIndex < viewModes.length - 1) {
            setCurrentViewModeIndex(currentViewModeIndex + 1);
            onViewModeChange(viewModes[currentViewModeIndex + 1]);
        }
    };

    return (
        <div className="flex justify-content-end align-items-center">
            <Button
                label="On Demand Template"
                icon="pi pi-download"
                onClick={openTemplate}
                className="p-mt-3"
            />
            <Button label="Open Signature Pad" icon="pi pi-pencil" disabled={workpack?.construction && workpack?.offshore && workpack?.onshore} onClick={openModal} className="ml-3" />
            
            
            
            <div className="inline-flex">
                <Button icon="pi pi-minus" className="m-2" rounded onClick={handleZoomOut} disabled={currentViewModeIndex === viewModes.length - 1} text raised aria-label="Zoom In" />
                <Button icon="pi pi-plus" className="m-2" rounded onClick={handleZoomIn} disabled={currentViewModeIndex === 0}  text raised aria-label="Zoom Out" />
            </div>
        </div>
    );
};